import { useMutate } from "../../../core/hooks/useMutate";

export function useUpdateApplicationNotification(notificationId: number) {
    return useMutate(`meta/notification/${notificationId}`, "PUT");
}
